import EmberRouter from '@embroider/router';
import type Owner from '@ember/owner';
import config from 'devloed-website/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;

  constructor(owner: Owner) {
    super(owner);

    this.on('routeDidChange', () => {
      window.scrollTo(0, 0);
    });
  }
}

Router.map(function () {
  this.route('services');
  this.route('experience');
  this.route('publications');
  this.route('contact');
  this.route('privacy');
  this.route('not-found', { path: '/*path' });
});
